export default "__VITE_ASSET__53abb0dc__"